import { Badge } from "@/components/ui/badge";
import { UserRole } from "@/interfaces/profile";
import {
  Shield,
  User,
  Crown,
  Briefcase,
  Star,
  LifeBuoy,
  Headphones,
  Gavel,
} from "lucide-react";

const roleConfig: Record<
  UserRole,
  { label: string; icon: any; className: string }
> = {
  SUPER: {
    label: "Super Admin",
    icon: Crown,
    className: "border-purple-200 text-purple-700 bg-purple-50",
  },
  ADMIN: {
    label: "Admin",
    icon: Shield,
    className: "border-blue-200 text-blue-700 bg-blue-50",
  },
  USER: {
    label: "User",
    icon: User,
    className: "border-gray-200 text-gray-700 bg-gray-50",
  },
  VENDOR: {
    label: "Vendor",
    icon: Briefcase,
    className: "border-emerald-200 text-emerald-700 bg-emerald-50",
  },
  VIP_USER: {
    label: "VIP User",
    icon: Star,
    className: "border-yellow-200 text-yellow-700 bg-yellow-50",
  },
  COMPLIANCE: {
    label: "Compliance",
    icon: Shield,
    className: "border-indigo-200 text-indigo-700 bg-indigo-50",
  },
  SUPPORT: {
    label: "Support",
    icon: Headphones,
    className: "border-sky-200 text-sky-700 bg-sky-50",
  },
  DISPUTE_MODERATOR: {
    label: "Dispute Mod",
    icon: Gavel,
    className: "border-red-200 text-red-700 bg-red-50",
  },
};

export function RoleBadge({ role }: { role: UserRole }) {
  const config = roleConfig[role];
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`flex items-center gap-1 px-2 py-0.5 text-xs font-medium ${config.className}`}
    >
      <Icon className="w-3.5 h-3.5 opacity-80" />
      {config.label}
    </Badge>
  );
}
